import gql from 'graphql-tag';

export default gql`
  mutation updateCallInfo($input: CreateCallInputObject) {
    updateCallInfo(input: $input) {
      callSid
    }
  }
`;
